/* ==========================================================================
   sk-drawer-hide-chat.js — Hide live-chat bubble when mobile drawer is open
   --------------------------------------------------------------------------
   Watches for mobile-nav drawer open/close state and toggles a body class.
   CSS (custom.css) uses body.sk-drawer-open selector to hide chat widgets.

   PageSpeed notes:
   - setTimeout polling (50ms/250ms/500ms) replaced by transitionend listener
     on the drawer element — fires exactly once per state change instead of
     3× per click.
   - nav element reference cached at bind time (was: getElementById() on each
     isDrawerOpen() call).
   - MutationObserver still catches edge cases (class/style changes from
     other scripts) as a safety net.
   ========================================================================== */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var BODY_CLASS = 'sk-drawer-open';
  var lastState = false;
  var navEl = null;

  function isDrawerOpen() {
    if (!navEl) return false;
    var cs = window.getComputedStyle(navEl);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    // Check transform: translate(-100%) means closed
    var transform = cs.transform;
    if (transform && transform !== 'none' && transform.indexOf('matrix') === 0) {
      // 6-value matrix: a, b, c, d, tx, ty — tx at index 4
      // Fast path: matrix(1, 0, 0, 1, -XXX, 0) means translated off-screen left
      var m = transform.match(/matrix\(([^)]+)\)/);
      if (m) {
        var parts = m[1].split(',');
        if (parts.length >= 6 && parseFloat(parts[4]) < -5) return false;
      }
    }
    // Fallback: scroll-locked + visible nav usually means drawer is open
    if (document.documentElement.classList.contains('scroll-locked') && cs.opacity !== '0') {
      return true;
    }
    return true;
  }

  function updateBodyClass() {
    var open = isDrawerOpen();
    if (open !== lastState) {
      lastState = open;
      document.body.classList.toggle(BODY_CLASS, open);
    }
  }

  function bind() {
    navEl = document.getElementById('site-mobile-nav');

    // transitionend on the nav fires when its transform/opacity animation completes.
    // Covers both open (transform: translateX(0)) and close (translateX(-100%)) transitions.
    if (navEl) {
      navEl.addEventListener('transitionend', function (e) {
        // Only care about transform/opacity transitions (layout-affecting)
        if (e.propertyName === 'transform' || e.propertyName === 'opacity') {
          updateBodyClass();
        }
      }, { passive: true });
    }

    // Still listen to clicks as a first-response trigger (before transitionend fires).
    // One setTimeout for animation settle catches cases where the drawer re-uses
    // transform values and the browser skips the transition.
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-menu-toggle], .site-header-menu-toggle, [data-mobile-nav-close]');
      if (toggle) {
        setTimeout(updateBodyClass, 60);
      }
    }, { passive: true });

    // MutationObserver: catches state changes that bypass transitions (scroll-lock,
    // aria-hidden toggles from other scripts).
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(updateBodyClass);
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      if (navEl) {
        mo.observe(navEl, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
      }
    }

    // hashchange: drawer closes when user navigates via href="#site-header-nav"
    window.addEventListener('hashchange', function () {
      setTimeout(updateBodyClass, 60);
    }, { passive: true });

    updateBodyClass();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
